<template>
  <footer class="site-footer">
    <div class="footer-content">
      <router-link to="/terms_of_service">Terms of Service</router-link>
      <router-link to="/privacy_policy">Privacy Policy</router-link>
    </div>
  </footer>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.site-footer {
  flex-shrink: 0;
  background: #111827;
  color: #f9fafb;
}

.footer-content {
  max-width: 1337px;
  margin: 0 auto;
  padding: 1.25rem 2rem;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;

  a {
    color: inherit;
    font-size: 0.95rem;
    font-weight: 700;
    text-decoration: none;

    &:hover {
      color: #fa5c80;
    }
  }
}
</style>
